import { render, staticRenderFns } from "./viewProgramaModules.vue?vue&type=template&id=ffb92910"
import script from "./viewProgramaModules.vue?vue&type=script&lang=js"
export * from "./viewProgramaModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports